<template>
  <div :class="['multi-basis', isMobile ? '' : 'multi-basis-pc']">
    <div class="nav-content">
      <div class="nav-title">{{ robotNav.tit }}</div>
      <div class="nav-desc">{{ robotNav.desc }}</div>
      <div class="list-content">
        <div
          v-for="(item, index) in robotNav.list"
          :key="index"
          class="list-item"
        >
          <div
            v-if="item.sub && item.sub.length > 0"
            class="list-item-title"
            @click="onClickGroup(item)"
          >
            <div class="list-item-title-name">{{ item.name }}</div>
            <img :class="['icon-arrow-right', item.isOpen ? 'arrow-down' : '']" src="../assets/arrow.svg" />
          </div>
          <div v-else class="list-item-title nav-link" @click="onClick(item)">
            <div class="list-item-title-name">{{ item.name }}</div>
          </div>

          <div v-if="item.isOpen" class="list-child-wrapper">
            <div
              v-for="(sub, subIndex) in item.sub"
              :key="subIndex"
              class="nav-link"
              @click="
                onClick(sub, {
                  robot_nav_event_type: 3,
                  robot_nav_first_menu_id: item.id,
                  robot_nav_first_menu_name: item.name,
                  robot_nav_second_menu_id: sub.id,
                  robot_nav_second_menu_name: sub.name,
                })
              "
            >
              {{ sub.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="btn-content">
        <div
          v-for="(item, index) in robotNav.buttons"
          :key="index"
          class="list-btn-cell"
        >
          <div class="nav-link" @click="onClick(item)">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robotNavMixin from './robot-nav-mixin.js';
/**
 * @component 机器人导航 - 多级基础型
 */
export default {
  mixins: [robotNavMixin],
  data() {
    return {
      arrItemIsOpen: [],
    };
  },
  methods: {
    // 展开分组
    onClickGroup(info) {
      let isOpen = info.isOpen || false;
      // 反转
      isOpen = !isOpen;

      this.$set(info, 'isOpen', isOpen);

      this.onClick(info);
    },
  },
};
</script>

<style lang="less" scoped>
.multi-basis {
  .nav-content {
    border-radius: 6px;
    padding-top: 12px;
    background-color: #ffffff;
    .nav-title {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      font-weight: bold;
      padding: 0 16px;
    }
    .nav-desc {
      font-size: 13px;
      color: #333333;
      line-height: 18px;
      margin: 6px 0 12px 0;
      padding: 0 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .list-content {
      padding: 0 16px;
      border-top: 1px solid #f8f9fb;
      &:first-child {
        border-top: 0;
      }
      .list-item {
        .list-item-title {
          height: 36px;
          color: #262d3d;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          border-top: 1px solid #f8f9fb;
          cursor: pointer;
          .icon-arrow-right {
            transform: rotate(90deg);
            width: 10px;
            height: 10px;
            cursor: pointer;
          }
          .arrow-down {
            transform: rotate(-90deg);
          }
        }
        &:first-child {
          .list-item-title {
            border: none;
          }
        }
        .list-child-wrapper {
          padding-left: 13px;
          .nav-link {
            cursor: pointer;
            color: #262d3d;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            border-top: 1px solid #f8f9fb;
          }
        }
      }
    }
    .btn-content {
      display: flex;
      flex-wrap: wrap;
      .list-btn-cell {
        flex: 1;
        min-width: 30%;
        border-top: 1px solid #f8f9fb;
        border-right: 1px solid #f8f9fb;
        display: flex;
        box-sizing: border-box;
        &:nth-child(3n) {
          border-right: 0;
        }
        &:last-child {
          border-right: 0;
        }
        .nav-link {
          cursor: pointer;
          flex: 1;
          height: 36px;
          color: @primary;
          text-align: center;
          line-height: 36px;
          box-sizing: border-box;
          margin-right: 1px solid #f8f9fb;
          font-size: 13px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.multi-basis-pc {
  width: 336px;
  .nav-content {
    border-radius: 6px;
    box-shadow: 0 1px 10px 0 #e1e6f0;
    margin-top: 2px;
    background-color: #fff;
  }
}
</style>
